import React from 'react';
import {
  Container,
  Header,
  KeepText,
  PlayButton,
  SuggestionActions,
  Text,
  TextContainer,
  Title,
  VoiceBadge,
} from './AiSuggestions.styles';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { ReactComponent as MicrophoneIcon } from '../../assets/icons/microphone-01.svg';
import { ReactComponent as PlayIcon } from '../../assets/icons/play.svg';

const AiSuggestions = ({ suggestions, setSuggestions, onSelectSuggestion, onPlaySuggestion }) => {
  return (
    <Container>
      <Header>
        <Title>AI Suggestions</Title>
        <CloseIcon color="#3e9be4" onClick={() => setSuggestions(null)} />
      </Header>
      {suggestions.map((suggestion, index) => {
        const hasVoice = !!suggestion.voiceBuffer;

        return (
          <TextContainer key={index} onClick={() => onSelectSuggestion(suggestion)} $hasVoice={hasVoice}>
            <Text>{suggestion.message}</Text>
            <SuggestionActions>
              {hasVoice && (
                <>
                  <VoiceBadge>
                    <MicrophoneIcon />
                    Voice
                  </VoiceBadge>
                  <PlayButton
                    type="button"
                    aria-label="Play voice suggestion"
                    onClick={e => {
                      e.stopPropagation();
                      onPlaySuggestion(suggestion);
                    }}>
                    <PlayIcon />
                  </PlayButton>
                </>
              )}
              {suggestion.isOriginal && <KeepText>Keep original</KeepText>}
            </SuggestionActions>
          </TextContainer>
        );
      })}
    </Container>
  );
};

export default AiSuggestions;
